import { Helmet } from "react-helmet-async";
import { brandConfig } from "config/brandConfig";
import { useLocation } from "react-router-dom";

type SEOMetaProps = {
  title: string;
  description: string;
  canonicalPath?: `/${string}`;
  index?: boolean;
  follow?: boolean;
  ogType?: "website" | "product";
  suffixBrand?: boolean;
};

export default function SEOMeta({
  title,
  description,
  canonicalPath,
  index = true,
  follow = true,
  ogType = "website",
  suffixBrand = true,
}: SEOMetaProps) {
  const location = useLocation();
  const { NDD, brandName, ogImage } = brandConfig;
  const canonicalPathResolved = canonicalPath ?? location.pathname;
  const canonicalUrl = new URL(
    canonicalPathResolved,
    brandConfig.NDD
  ).toString();
  const robotsContent = `${index ? "index" : "noindex"}, ${
    follow ? "follow" : "nofollow"
  }`;
  const ogImageUrl = `${NDD}${ogImage}`;
  const fullTitle = suffixBrand ? `${title} - ${brandName}` : title;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={robotsContent} />
      {/* Open Graph */}
      <meta property="og:title" content={`${title} - ${brandName}`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />{" "}
      <meta property="og:image" content={ogImageUrl} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title} - ${brandName}`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />
    </Helmet>
  );
}
